import { configureStore, combineReducers } from "@reduxjs/toolkit";
import uiReducer from "./slices/uiSlice";

const rootReducer = combineReducers({
  ui: uiReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Enable hot module replacement for reducers in development (CRA)
declare const module: any;
if (process.env.NODE_ENV !== "production" && typeof module !== "undefined" && module.hot) {
  module.hot.accept("./slices/uiSlice", () => {
    const nextUiReducer = require("./slices/uiSlice").default as typeof uiReducer;
    const nextRootReducer = combineReducers({ ui: nextUiReducer });
    store.replaceReducer(nextRootReducer as typeof rootReducer);
  });
}
